module.exports = __webpack_public_path__ + "static/media/eumodicogryllus_bordigalensis.42086cdc.jpg";